// Generates an assignment YAML of type v2_memo (the matching-memory runner)
// out of the same `word - переклад` list every other words generator eats.
//
// Memo is WordCards' data shape with a different runner, so this is
// deliberately the twin of `word-wordcards.js`: only the word tag is emitted
// and the EN↔UA pairing is resolved from the vocabulary bank at render time.
// The extra knob is `pairs` — how many pairs the runner deals.
//
// converts a text like:
// word - переклад
// word - переклад
//
// to:
// version: 2
// type: memo
// name: Topic memo
// level: a1
// pairs: 6
// questions:
//   - [[[word]]]
//   - [[[word]]]

import { yamlScalar } from './yaml'

// The runner deals `min(8, count(questions))` when `pairs` is omitted; 8 pairs
// is 16 tiles, which is already the ceiling for a phone screen. We write the
// number out explicitly so the teacher can see and tune it.
const MAX_PAIRS = 8

export function wordMemoGenerator(rawText, topic, levelString, limit, shuffle = true) {
  const level = levelString.toUpperCase()
  const lines = rawText.split('\n')

  let words = lines.map((line) => {
    const [word,] = line.split(' - ')
    return word && word.trim() ? `[[[${word.trim()}]]]` : null
  }).filter((w) => w)

  // shuffle words
  if (shuffle) {
    for (let i = words.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [words[i], words[j]] = [words[j], words[i]]
    }
  }

  words = words.slice(0, limit || words.length)

  if (!words.length) {
    return null
  }

  const content = `version: 2
type: memo
name: ${yamlScalar(`${topic} memo`)}
level: ${level}
pairs: ${Math.min(words.length, MAX_PAIRS)}
questions:
  - ${words.join('\n  - ')}
`
  return content
}
